import React from 'react';
import PropTypes from 'prop-types';

import Button from 'styled/Buttons/PrimaryButton';
import Input from 'styled/Input';
import CloseButton from 'styled/Buttons/CloseButton';
import IconClose from 'icons/Close';

import FormStyled from './FormStyled';
import TextareaStyled from './TextareaStyled';
import Title from './Title';
import IconWrapper from './IconWrapper';

export class MaterialForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      title: this.props.title,
      description: this.props.description,
      price: this.props.price,
    };

    this.handleTitleChange = this.handleFieldChange.bind(this, 'title');
    this.handleDescriptionChange = this.handleFieldChange.bind(this, 'description');
  }

  get price() {
    if (this.state.price === 0) return 0;
    if (!this.state.price) return '';
    return this.state.price;
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.title.trim()) return;

    this.props.onSubmit({ ...this.state, price: this.state.price || 0 });
  }

  handlePriceChange = ({ target }) => {
    if (this.props.status === 'accepted') return;

    this.setState({ price: parseInt(target.value, 10) });
  }

  handleFieldChange(field, event) {
    this.setState({ [field]: event.target.value });
  }

  render() {
    return (
      <FormStyled onSubmit={this.handleSubmit}>
        <div style={{ width: '800px', marginBottom: '32px' }}>
          <Title htmlFor="title">Заголовок</Title>

          <Input
            id="title"
            type="text"
            value={this.state.title}
            onChange={this.handleTitleChange}
            required
            autoFocus
          />

          <Title htmlFor="description">Описание</Title>

          <TextareaStyled
            id="description"
            value={this.state.description}
            onChange={this.handleDescriptionChange}
          />

          <Title htmlFor="price">Вознаграждение</Title>

          <div style={{ position: 'relative', width: '300px' }}>
            <Input
              style={{ paddingRight: '15px' }}
              disabled={this.props.status === 'accepted'}
              id="price"
              type="number"
              value={this.price}
              onChange={this.handlePriceChange}
              min="0"
              max="999999"
              step="100"
            />

            <IconWrapper>₽</IconWrapper>
          </div>
        </div>

        <Button
          style={{ width: '240px', height: '40px' }}
          type="submit"
        >
          Сохранить
        </Button>

        <CloseButton onClick={this.props.onClose}>
          <IconClose />
        </CloseButton>
      </FormStyled>
    );
  }
}

MaterialForm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.number,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  status: PropTypes.oneOf(['created', 'accepted', 'rejected']),
};

MaterialForm.defaultProps = {
  title: '',
  description: '',
  price: 0,
  onClose: () => {},
  onSubmit: () => {},
  status: 'created',
};

export default MaterialForm;
